export default __webpack_public_path__ + "static/media/happy_hour_menu.b5a30e9d.png";